import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
const consumerLinks = [{
  label: "Home",
  to: "/"
}, {
  label: "What we do",
  to: "Wat doen we"
}, {
  label: "Privacy",
  to: "#"
}, {
  label: "Legal",
  to: "#"
}, {
  label: "Contact",
  to: "#"
}, {
  label: "Disclaimer",
  to: "#"
}];
const businessLinks = [{
  label: "How it works",
  to: "Hoe werkt het"
}];
export default function FooterInformation() {
  return <section id="footer-informatie" className="bg-muted py-20 px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-10">
          {}
          <div className="flex flex-col gap-4">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604417/img/asbestofferte_logo.png" alt="AsbestOfferte Logo" className="h-7 w-auto object-contain object-left" />
            <p className="text-sm text-muted-foreground font-sans leading-relaxed">Dien een aanvraag in voor gratis offertes. Vergelijk vervolgens tot 5 bedrijven, kies de offerte die het beste bij je past en bespaar tot 40%.</p>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h3 className="text-lg font-serif font-bold text-foreground">Voor particulieren</h3>
            <ul className="flex flex-col gap-2">
              {consumerLinks.map((link, i) => <li key={link.label} data-index={i}>
                  <Link to={link.to} className="text-sm font-sans text-muted-foreground hover:text-primary transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h3 className="text-lg font-serif font-bold text-foreground">Voor bedrijven</h3>
            <ul className="flex flex-col gap-2">
              {businessLinks.map((link, i) => <li key={link.label} data-index={i}>
                  <Link to={link.to} className="text-sm font-sans text-muted-foreground hover:text-primary transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h3 className="text-lg font-serif font-bold text-foreground">
              Need Help?
            </h3>
            <Link to="mailto:info@asbestofferte.nl" className="text-sm font-sans text-muted-foreground hover:text-primary transition-colors duration-200">Info@ekonorm.be</Link>
            <img src="https://nice-frog.10web.cloud/wp-content/uploads/2026/03/avatar_robert_c.webp" alt="Customer Support Representative" className="mt-2 w-full max-w-[200px] h-auto rounded-md object-cover shadow-sm" />
          </div>
        </div>

        {}
        <div className="pt-6">
          <Separator className="mb-6 bg-border" />
          <p className="text-center text-sm text-muted-foreground font-sans">
            © 2026 AsbestOfferte
          </p>
        </div>
      </div>
    </section>;
}